module.exports = __webpack_public_path__ + "img/315.e52d5dc3.jpg";